import React from 'react'
import ThumbUpTwoToneIcon from '@mui/icons-material/ThumbUpTwoTone';
import { Button } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const showToastMessage = () => {
  toast('Thank You !', {
    position: toast.POSITION.BOTTOM_RIGHT,
  });
};
function Footer() {
  return (
    <div style={{ textAlign: 'center', padding: '5px 0', color: "red", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
      <h7>Made By  <FavoriteIcon />  Saurabh Singh </h7>
      <Button type='button' onClick={showToastMessage}>Like it Guys
        <ThumbUpTwoToneIcon />
      </Button>
      <ToastContainer />
    </div>
  )
}

export default Footer